import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => theme.typography)

export default useStyles
